import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./GameDisplay.css";

const API_URL = process.env.REACT_APP_API_URL;

const GameDisplay = () => {
  const { playerId } = useParams();
  const [playerName, setPlayerName] = useState("");
  const [targetName, setTargetName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [timeLeft, setTimeLeft] = useState("");
  
  useEffect(() => {
    const fetchPlayerAndTarget = async () => {
      try {
        const res = await fetch(`${API_URL}/players/${playerId}/self`);
        if (!res.ok) {
          const data = await res.json();
          setError(data.error || "Error fetching player info");
          setLoading(false);
          return;
        }
        const data = await res.json();
        setPlayerName(data.name);

        const targetRes = await fetch(`${API_URL}/players/${playerId}/target`);
        if (!targetRes.ok) {
          const targetData = await targetRes.json();
          setError(targetData.error || "Error fetching target");
          setLoading(false);
          return;
        }
        const targetData = await targetRes.json();
        setTargetName(targetData.target.name);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError("Something went wrong");
        setLoading(false);
      }
    };

    fetchPlayerAndTarget();
  }, [playerId]);

  // Countdown timer
  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const year = now.getMonth() === 11 && now.getDate() > 25 ? now.getFullYear() + 1 : now.getFullYear();
      const deadline = new Date(`${year}-12-25T00:00:00`);
      const diff = deadline - now;

      if (diff <= 0) {
        setTimeLeft("It's Christmas!");
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  }, []);

  if (loading) {
    return (
      <div className="game-container">
        <p>Loading your game...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="game-container">
        <p className="game-error">{error}</p>
      </div>
    );
  }

  return (
    <div className="game-container">
      <h1 className="game-title">Hello {playerName}!</h1>
      <p className="game-subtitle">
        Your target is: <strong>{targetName}</strong>
      </p>
      <p className="game-countdown">Time until Exchange: {timeLeft}</p>
    </div>
  );
};

export default GameDisplay;
